export default (clientHttp) => ({
  read(query = '') {
    return clientHttp.get(`v2/user/signatory_houses${query}`)
  },
})
